import React from "react";
import { removeMarkdownSyntax } from "../external";
import { createElementClass, createModifierClass, toKebabCase } from "../helpers";
export var Heading = function Heading(_a) {
  var _b = _a.level,
      level = _b === void 0 ? 6 : _b,
      headings = _a.headings,
      _c = _a.headingPrefix,
      headingPrefix = _c === void 0 ? "" : _c,
      children = _a.children;

  if (!children) {
    return null;
  }

  var heading = children.find(function (child) {
    return child.key && child.key.startsWith("text");
  });

  if (!heading) {
    return null;
  }

  heading = heading.props && heading.props.value;

  if (!heading) {
    return null;
  }

  heading = headingPrefix ? headingPrefix + "-" + heading : heading;

  if (headings.has(heading)) {
    if (/[1-9]$/.test(heading)) {
      heading = heading + "-" + (Number(heading[heading.length - 1]) + 1);
    } else {
      heading = heading + "-1";
    }
  }

  heading = removeMarkdownSyntax(heading);
  headings.add(heading);
  var id = toKebabCase(heading);
  return React.createElement("h" + level, {
    children: children,
    className: createElementClass("heading") + " " + createModifierClass("level-" + level, "heading"),
    id: id
  });
};